import { Price } from '../../../../../../types';
import { IListPrices, IPriceListPanelProps, ICommonListProps } from '../types';

export function getListLimits(prices: IListPrices, isGroupedList: boolean) {
  const mainLimit = isGroupedList ? 10 : 15;
  const secondaryLimit = 5;
  const mainListLimit =
    prices.mainList.length <= mainLimit ? prices.mainList.length : mainLimit;
  const stockStatusUnknownListLimit =
    prices.stockStatusUnknownList &&
    prices.stockStatusUnknownList.length <= secondaryLimit
      ? prices.stockStatusUnknownList.length
      : secondaryLimit;
  return { mainListLimit, stockStatusUnknownListLimit };
}

export function getListPrices(
  sortedPrices: Price[] | null | undefined,
  splitList: boolean
): IListPrices {
  if (!splitList) {
    return { mainList: sortedPrices || [], stockStatusUnknownList: null };
  }

  return {
    mainList: sortedPrices?.filter(f => !f.uncertainData) || [],
    stockStatusUnknownList: sortedPrices?.filter(f => f.uncertainData) || [],
  };
}

export const getCommonListProps = (
  props: IPriceListPanelProps
): ICommonListProps => {
  return {
    productId: props.productId,
    productName: props.productName,
    media: props.media,
    brand: props.brand,
    campaign: props.campaign,
    priceDisplay: props.priceDisplay,
    currentSorting: props.currentSorting,
    adOffset: props.adOffset,
  };
};
